"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenType = void 0;
var TokenType;
(function (TokenType) {
    TokenType[TokenType["WHITESPACE"] = 0] = "WHITESPACE";
    TokenType[TokenType["STRING"] = 1] = "STRING";
    TokenType[TokenType["NUMBER"] = 2] = "NUMBER";
    TokenType[TokenType["INTEGER"] = 3] = "INTEGER";
    TokenType[TokenType["OPERATOR"] = 4] = "OPERATOR";
    TokenType[TokenType["VARIABLE"] = 5] = "VARIABLE";
    TokenType[TokenType["PLACEHOLDER"] = 6] = "PLACEHOLDER";
    TokenType[TokenType["FUNCTION"] = 7] = "FUNCTION";
    TokenType[TokenType["PARENS"] = 8] = "PARENS";
    TokenType[TokenType["SQUARE_PARENS"] = 9] = "SQUARE_PARENS";
    TokenType[TokenType["COMMA"] = 10] = "COMMA";
    TokenType[TokenType["SPREAD"] = 11] = "SPREAD";
    TokenType[TokenType["SPEECH"] = 12] = "SPEECH";
    TokenType[TokenType["COMPARISON"] = 13] = "COMPARISON";
    TokenType[TokenType["UNKNOWN"] = 14] = "UNKNOWN";
    TokenType[TokenType["INVALID"] = 15] = "INVALID";
    TokenType[TokenType["ANY_VALUE"] = 16] = "ANY_VALUE";
    TokenType[TokenType["TOKENS"] = 17] = "TOKENS";
})(TokenType || (exports.TokenType = TokenType = {}));
